import axios from 'axios';

axios.defaults.baseURL = 'https://console.arashivision.com';

export default axios;



// WEBPACK FOOTER //
// ./src/utils/request.js